import { render, staticRenderFns } from "./VoteStep.vue?vue&type=template&id=49ce926f"
import script from "./VoteStep.vue?vue&type=script&lang=js"
export * from "./VoteStep.vue?vue&type=script&lang=js"
import style0 from "./VoteStep.vue?vue&type=style&index=0&id=49ce926f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports